<app-titolo-subtitolo
  [titolo]="isUtenteGo ? 'Report Tematico' : 'Report di Sostenibilità'"
  [paddingTop]="10"
  [isArchiviato]="isArchiviato()"
></app-titolo-subtitolo>

<div mat-dialog-content class="dialog-center-cont" style="padding: 0px !important">
  <app-spinner-overlay></app-spinner-overlay>
  <mat-stepper
    [linear]="!isPubblicato() && !isArchiviato()"
    #stepper
    (selectionChange)="cambioStep($event)"
  >
    <!-- STEP 1 -->
    <mat-step [stepControl]="formCreazioneBilancio" [editable]="true">
      <ng-scrollbar [visibility]="'hover'">
        <ng-template matStepLabel> Report </ng-template>

        <form
          class="form-step1"
          [formGroup]="formCreazioneBilancio"
          [alignItems]="'flex-start'"
          appFormContainer
          [larghezza]="12"
          [gap]="10"
          [rowGap]="5"
          style="align-items: center"
        >
          <ng-container *ngIf="!isUtenteGo">
            <div appFormElement [larghezza]="12" [riempi]="true">
              <div class="titolo-sezione-dialog">Creazione Report di Sostenibilità</div>
              <div class="descrizione-sezione-dialog">
                Seleziona l'anno e definisci gli standard di rendicontazione e le normative al quale
                allineare il Report di Sostenibilità. <br />
                Scegli tra l'approccio generico e quello settoriale. Se selezioni l'approccio
                settoriale il sistema elaborerà un framework basato sulle specificità del settore di
                appartenenza. La scelta del sotto-settore aumenterà l'accuratezza dell'approccio
                selezionato.
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="isUtenteGo">
            <div appFormElement [larghezza]="12" [riempi]="true">
              <div class="titolo-sezione-dialog">Creazione Report Tematico</div>
              <div class="descrizione-sezione-dialog">
                Seleziona l'anno e l'Assessment di riferimento per individuare al meglio i tuoi
                elementi per il tuo Report Tematico.
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="!isUtenteGo">
            <!-- MOSTRA SOLO SE UTENTE NON GO -->

            <div style="display: flex; flex-direction: column; flex: none; padding-right: 15px">
              <mat-label>Framework</mat-label>
              <mat-radio-group
                class="radio-tipo-sett"
                aria-label="Framework"
                formControlName="tipoSettore"
              >
                <div class="radio-container">
                  <mat-radio-button
                    aria-label="Generico"
                    value="GENERALE"
                    [disabled]="
                      this.formCreazioneBilancio.get('id')?.value || !this.settoreGenerale
                    "
                  >
                    Generale
                  </mat-radio-button>
                  <div class="eti-check">
                    <mat-icon matTooltip="Adatto ad aziende di ogni settore" class="info-icon">
                      info_outline
                    </mat-icon>
                  </div>
                </div>

                <div class="radio-container">
                  <mat-radio-button
                    aria-label="Specifico"
                    value="SPECIFICO"
                    [disabled]="
                      this.formCreazioneBilancio.get('id')?.value || !this.settoriAzienda.length
                    "
                  >
                    Settoriale
                  </mat-radio-button>
                  @if (
                    !this.formCreazioneBilancio.get('id')?.value && !this.settoriAzienda.length
                  ) {
                    <div class="eti-check">
                      <mat-icon matTooltip="Estensione settoriale non attiva" class="info-icon">
                        info_outline
                      </mat-icon>
                    </div>
                  } @else {
                    <div class="eti-check">
                      <mat-icon
                        matTooltip="Sviluppato ad hoc per il settore di appartenenza dell'azienda"
                        class="info-icon"
                      >
                        info_outline
                      </mat-icon>
                    </div>
                  }
                </div>
              </mat-radio-group>
            </div>
          </ng-container>

          <mat-form-field style="max-width: 150px">
            <mat-label>Anno</mat-label>
            <mat-select formControlName="anno" placeholder="Anno">
              <mat-option
                *ngFor="let aa of arrayAnni"
                [value]="aa"
                [disabled]="ctrAnnoBilanciUtilizzati(aa)"
                >{{ aa }}</mat-option
              >
            </mat-select>
          </mat-form-field>

          <ng-container *ngIf="!isUtenteGo">
            <!-- MOSTRA SOLO SE UTENTE NON GO -->
            <mat-form-field
              appFormElement
              [larghezza]="2"
              class="input-form"
              [riempi]="true"
              *ngIf="this.formCreazioneBilancio.get('tipoSettore')?.value === 'SPECIFICO'"
            >
              <mat-label>Settore</mat-label>
              <mat-select
                formControlName="settori"
                placeholder="Settore"
                [compareWith]="compareById"
              >
                <mat-option
                  *ngFor="let set of settoriAzienda"
                  [value]="set"
                  [disabled]="ctrSettoreBilanciUtilizzati(set)"
                  >{{ set.titolo }}</mat-option
                >
              </mat-select>
            </mat-form-field>

            <mat-form-field
              appFormElement
              [larghezza]="4"
              class="input-form"
              [riempi]="true"
              *ngIf="
                this.formCreazioneBilancio.get('tipoSettore')?.value === 'SPECIFICO' &&
                arraySottoSettori?.length
              "
            >
              <mat-label>Sotto-settore</mat-label>
              <mat-select
                formControlName="sottoSettori"
                placeholder="Sotto-ettore"
                [compareWith]="compareById"
                multiple
              >
                <mat-option *ngFor="let sottoSet of arraySottoSettori" [value]="sottoSet">{{
                  sottoSet.titolo
                }}</mat-option>
              </mat-select>
            </mat-form-field>

            <div appFormElement [larghezza]="6">
              <app-select-custom
                [nascondiFigli]="true"
                formControlName="stdr"
                [isBilancio]="true"
                titolo="Standard di rendicontazione"
              ></app-select-custom>
            </div>

            <div appFormElement [larghezza]="6">
              <app-select-custom
                [nascondiFigli]="true"
                formControlName="compliance"
                [isBilancio]="true"
                titolo="Compliance Normativi"
              ></app-select-custom>
            </div>

            <div appFormElement [larghezza]="12">
              <app-separatore-label [styleSeparatore]="'small'"></app-separatore-label>
            </div>

            <div appFormElement [larghezza]="12" [riempi]="true">
              <div class="titolo-sezione-dialog">Informazioni Aziendali</div>

              <div class="descrizione-sezione-dialog">
                Compila le informazioni dimensionali dell'azienda per verificare il regime di
                rendicontazione di sostenibilità da utilizzare.
              </div>
            </div>

            <mat-form-field appFormElement [larghezza]="4" [riempi]="true">
              <mat-label>Fatturato</mat-label>
              <input
                matInput
                placeholder="Fatturato"
                formControlName="fatturato"
                type="number"
                appInputNumber
                inputmode="numeric"
                min="0"
                max="999999999999"
                (keydown)="onKeyDown($event)"
                (keyup)="keyUpSoglie()"
              />
              <mat-error appFormError></mat-error>
            </mat-form-field>

            <mat-form-field appFormElement [larghezza]="4" [riempi]="true">
              <mat-label>Nr. Dipendenti</mat-label>
              <input
                matInput
                placeholder="Nr. Dipendenti"
                formControlName="nrDipendenti"
                type="number"
                appInputNumber
                min="0"
                max="2147483646"
                (keydown)="onKeyDownDip($event)"
                inputmode="numeric"
                (keyup)="keyUpSoglie()"
              />
              <mat-error appFormError></mat-error>
            </mat-form-field>

            <div appFormElement [larghezza]="12">
              <app-separatore-label [styleSeparatore]="'small'"></app-separatore-label>
            </div>

            <div appFormElement [larghezza]="12" [riempi]="true">
              <div class="titolo-sezione-dialog">
                Non partire da zero, lega il tuo report ad altre attività
              </div>

              <div class="descrizione-sezione-dialog">
                Collegando altri moduli al bilancio potrai utilizzare le informazioni inserite
                precedentemente. Selezionare l'Analisi di Materialità avrà un impatto sulla scelta
                delle tematiche di sostenibilità da rendicontare.
              </div>
            </div>

            <app-inclusione-moduli
              [annoModulo]="this.formCreazioneBilancio.get('anno')?.value"
              [idModulo]="this.formCreazioneBilancio.get('id')?.value"
              [settore]="this.formCreazioneBilancio.get('settori')?.value"
              [sottoSettore]="this.formCreazioneBilancio.get('sottoSettori')?.value"
              [tipoModulo]="'BILANCIO'"
              [idModuiliInclusi]="idModuliInclusi"
              [isUtenteGo]="isUtenteGo"
              [isSoglieSuperate]="isSogliaSuperata()"
            ></app-inclusione-moduli>
          </ng-container>
        </form>
      </ng-scrollbar>
    </mat-step>

    <!-- STEP 3 -->
    <mat-step [editable]="true" errorMessage="Campi obbligatori">
      <ng-template matStepLabel> Informativa </ng-template>
      <ng-scrollbar [visibility]="'hover'">
        <div appFormElement [larghezza]="3" [riempi]="true" style="padding-right: 20px !important">
          <div class="cont-titolo-targhettina">
            <div class="titolo-sezione-dialog">Informativa Aziendale</div>
            @if (isStepConsigliato('INFORMATIVA')) {
              <div
                class="targhettina-consigliato"
                [matTooltip]="'Consigliato per ' + mappaPriotitaStep['INFORMATIVA']?.perStdr"
                matTooltipPosition="right"
              >
                <mat-icon class="material-icons-outlined" style="transform: scale(0.9)">
                  emoji_objects
                </mat-icon>
                *Consigliato
              </div>
            }
          </div>
          <div class="descrizione-sezione-dialog">
            L'informativa aziendale contiene dati rilevanti nella redazione del Report di
            Sostenibilità, come ad esempio il periodo di rendicontazione, il campo di applicazione
            ed altri dati definiti dagli standard di reportistica. <br />
            Assegna la compilazione dell'informativa aziendale ad una figura aziendale tramite il
            pulsante
            <i>Figura</i> e notifica l'attività attraverso il pulsante <i>invia</i> , oppure
            compilala adesso attraverso il pulsante di <i>compilazione</i>. Monitora la compilazione
            da parte della figura aziendale attraverso il simbolo di <i>Stato</i>.

            @if (isStepConsigliato('INFORMATIVA')) {
              <br />
              <strong>Step consigliato:</strong> la compilazione delle informazioni non è necessaria
              ma è consigliata per allinearsi alle richieste informative degli
              <i>standard / linee guide selezionate.</i>
            }
            @if (isStepLibero('INFORMATIVA')) {
              <br />
              <strong> Step non obbligatorio:</strong> la compilazione delle informazioni non è
              necessaria per allinearsi alle richieste informative degli
              <i>standard / linee guide selezionate.</i>
            }
          </div>
          <div class="card-tabella mat-elevation-z2">
            <div class="cont-tabella">
              <table
                mat-table
                [dataSource]="arrayInformativa ? arrayInformativa : []"
                *ngIf="arrayInformativa"
              >
                <ng-container matColumnDef="figura">
                  <th mat-header-cell class="titolo-colonna" *matHeaderCellDef>Figure Aziendali</th>
                  <td mat-cell class="dati-righe" *matCellDef="let elem">{{ elem?.figura }}</td>
                </ng-container>
                <ng-container matColumnDef="nome">
                  <th mat-header-cell class="titolo-colonna" *matHeaderCellDef>Nome</th>
                  <td mat-cell class="dati-righe" *matCellDef="let elem">{{ elem?.nome }}</td>
                </ng-container>
                <ng-container matColumnDef="email">
                  <th mat-header-cell class="titolo-colonna" *matHeaderCellDef>Email</th>
                  <td mat-cell class="dati-righe" *matCellDef="let elem">{{ elem?.email }}</td>
                </ng-container>
                <ng-container matColumnDef="stato">
                  <th mat-header-cell class="titolo-colonna" *matHeaderCellDef>Stato</th>
                  <td mat-cell class="dati-righe" *matCellDef="let elem">
                    <!-- {{ elem?.stato }} -->
                    <div
                      *ngIf="elem?.stato === 'ROSSO'"
                      style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        background-color: #cf5b61;
                        width: 25px;
                        text-align: center;
                        border-radius: 15px;
                        height: 25px;
                      "
                    ></div>
                    <div
                      *ngIf="elem?.stato === 'GIALLO'"
                      style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        background-color: #c7a045;
                        width: 25px;
                        text-align: center;
                        border-radius: 15px;
                        height: 25px;
                      "
                    ></div>
                    <div
                      *ngIf="elem?.stato === 'VERDE'"
                      style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        background-color: #729373;
                        width: 25px;
                        text-align: center;
                        border-radius: 15px;
                        height: 25px;
                      "
                    ></div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="azioni">
                  <th
                    mat-header-cell
                    class="titolo-colonna"
                    *matHeaderCellDef
                    style="text-align: right"
                  >
                    Azioni
                  </th>
                  <td mat-cell class="dati-righe" *matCellDef="let elem">
                    <div
                      appFormElement
                      [larghezza]="0"
                      [minWidth]="50"
                      style="display: flex; justify-content: end; column-gap: 10px"
                    >
                      <button
                        class="icone-button"
                        mat-icon-button
                        (click)="compilazione(elem)"
                        [title]="
                          elem?.stato === 'VERDE' || isPermessoSoloRead ? 'Visualizza' : 'Compila'
                        "
                        [attr.aria-label]="
                          elem?.stato === 'VERDE' || isPermessoSoloRead ? 'Visualizza' : 'Compila'
                        "
                      >
                        <mat-icon class="icone">
                          {{
                            elem?.stato === 'VERDE' || isPermessoSoloRead
                              ? 'visibility'
                              : 'history_edu'
                          }}
                        </mat-icon>
                      </button>
                      @if (elem.stato !== 'VERDE' && !isPermessoSoloRead) {
                        <button
                          class="icone-button"
                          mat-icon-button
                          (click)="figura(elem)"
                          title="Figura"
                          [attr.aria-label]="'Figura'"
                        >
                          <mat-icon class="icone"> person </mat-icon>
                        </button>
                      }
                      @if (!isPermessoSoloRead && elem.stato !== 'VERDE') {
                        @if (!elem.ultimoInvio && isPermessoInvioMail) {
                          <button
                            class="icone-button"
                            mat-icon-button
                            (click)="inviaMailInformativa(elem)"
                            title="Invia"
                            [attr.aria-label]="'Invia'"
                          >
                            <mat-icon class="icone"> mail </mat-icon>
                          </button>
                        }
                        @if (elem.ultimoInvio !== '' && isPermessoInvioMail) {
                          <button
                            class="icone-button"
                            mat-icon-button
                            (click)="inviaNotifInformativa(elem)"
                            title="Notifica"
                            [attr.aria-label]="'Notifica'"
                          >
                            <mat-icon class="icone"> notifications_active </mat-icon>
                          </button>
                        }
                        @if (isPermessoStama) {
                          <!-- STAMPA INFORMATIVA -->
                          <button
                            class="icone-button"
                            mat-icon-button
                            (click)="stampaInformativa()"
                            title="Anteprima"
                          >
                            <mat-icon class="icone"> print </mat-icon>
                          </button>
                        }
                      }
                    </div>
                  </td>
                </ng-container>
                <tr
                  mat-header-row
                  *matHeaderRowDef="displayedColumns; sticky: true"
                  class="riga-colonna"
                ></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns" class="riga-riga"></tr>
              </table>
            </div>
          </div>
        </div>
      </ng-scrollbar>
    </mat-step>

    <!-- ? CREAZIONE SOURVEY  -->
    <mat-step [editable]="true" errorMessage="Campi obbligatori">
      <ng-template matStepLabel> Tematiche </ng-template>
      <div style="padding-right: 20px !important; height: 100%">
        <app-cfg-questionario
          #surveyComp
          [isPermessoSoloRead]="isPermessoSoloRead"
          [tipoQuestionario]="'BILANCIO'"
          [cfgQuestionario]="bilancio"
          [idSostenibilita]="formCreazioneBilancio.get('id')?.value"
          [nascondiTitolo]="true"
        ></app-cfg-questionario>
      </div>
    </mat-step>
    <!--  ---------------------- I M P A T T I ---------- -->
    <mat-step>
      <ng-template matStepLabel> Impatti </ng-template>

      <div appFormContainer [larghezza]="2" class="cont-titolo-step-selezione">
        <div appFormElement [larghezza]="1" [riempi]="true">
          <div class="cont-titolo-targhettina">
            <div class="titolo-sezione-dialog">Selezione degli Impatti</div>

            @if (isStepConsigliato('IMPATTI')) {
              <div
                class="targhettina-consigliato"
                [matTooltip]="'Consigliato per ' + mappaPriotitaStep['IMPATTI']?.perStdr"
                matTooltipPosition="right"
              >
                <mat-icon class="material-icons-outlined" style="transform: scale(0.9)">
                  emoji_objects
                </mat-icon>
                *Consigliato
              </div>
            }
          </div>
          <div class="descrizione-sezione-dialog">
            Gli impatti descrivono sia le conseguenze che un tema, problema o fattore di
            sostenibilità hanno sull'azienda stessa, sia l'effetto che l'azienda genera
            sull'ambiente e sugli stakeholder.<br />

            @if (isStepConsigliato('IMPATTI')) {
              <strong>Step consigliato:</strong> si raccomanda la compilazione degli impatti
              consigliati per allinearsi alle richieste informative degli
              <i>standard / linee guide selezionate.</i>
            }
            @if (isStepLibero('IMPATTI')) {
              <strong>Step non obbligatorio:</strong> la compilazione delle informazioni non è
              necessaria per allinearsi alle richieste informative degli
              <i>standard / linee guide selezionate.</i>
            }
            @if (isStepObbligatorio('IMPATTI')) {
              <br />
              Per ogni tematica scelta, è necessario selezionare almeno un impatto
            }
          </div>
        </div>
      </div>
      <app-selezione-impatti-bilancio
        nomeModulo="BILANCIO"
        style="padding-right: 20px"
        [prioritaStep]="mappaPriotitaStep['IMPATTI']?.valore"
        [isPermessoSoloRead]="isPermessoSoloRead"
        [objQuestionario]="objQuestionarioImpatti"
        chiaveElemento="elementi"
        [idContest]="this.formCreazioneBilancio.get('id')?.value"
        [stato]="bilancio?.stato"
        [isImpatto]="true"
        [isMaterialitaSelezionata]="isMaterialitaSelezionata"
        chiaveElementoSelezione="impatto"
        [settore]="bilancio?.settori"
      >
      </app-selezione-impatti-bilancio>
    </mat-step>
    <!--  ---------------------- I M P E G N I ---------- -->
    <mat-step>
      <ng-template matStepLabel> Impegni </ng-template>
      <div appFormContainer [larghezza]="2" class="cont-titolo-step-selezione">
        <div appFormElement [larghezza]="1" [riempi]="true">
          <div class="cont-titolo-targhettina">
            <div class="titolo-sezione-dialog">Selezione degli Impegni</div>
            @if (isStepConsigliato('IMPEGNI')) {
              <div
                class="targhettina-consigliato"
                [matTooltip]="'Consigliato per ' + mappaPriotitaStep['IMPEGNI']?.perStdr"
                matTooltipPosition="right"
              >
                <mat-icon class="material-icons-outlined" style="transform: scale(0.9)">
                  emoji_objects
                </mat-icon>
                *Consigliato
              </div>
            }
          </div>

          <div class="descrizione-sezione-dialog">
            Gli impegni rappresentano delle dichiarazioni di intento dell'azienda ad operare creando
            impatti positivi e limitando quelli negativi rispetto alle specifiche tematiche di
            sostenibilità. <br />

            @if (isStepConsigliato('IMPEGNI')) {
              <strong>Step consigliato:</strong> si raccomanda la compilazione degli impegni
              consigliati per allinearsi alle richieste informative degli
              <i>standard / linee guide selezionate.</i>
            }
            @if (isStepLibero('IMPEGNI')) {
              <strong>Step non obbligatorio:</strong> la compilazione delle informazioni non è
              necessaria per allinearsi alle richieste informative degli
              <i>standard / linee guide selezionate.</i>
            }
            @if (isStepObbligatorio('IMPEGNI')) {
              <br />
              Seleziona almeno un impegno aziendale e descrivilo attraverso la compilazione.
              Scegliendo dalla lista proposta troverai linee guida ad hoc per la compilazione.
            }
          </div>
        </div>
      </div>

      <app-selezione-impegni-bilancio
        nomeModulo="BILANCIO"
        [prioritaStep]="mappaPriotitaStep['IMPEGNI']?.valore"
        style="padding-right: 20px"
        [isPermessoSoloRead]="isPermessoSoloRead"
        [objQuestionario]="objQuestionarioImpegni"
        chiaveElemento="elementi"
        [idContest]="this.formCreazioneBilancio.get('id')?.value"
        [stato]="bilancio?.stato"
        chiaveElementoSelezione="impegno"
        [settore]="bilancio?.settori"
      >
      </app-selezione-impegni-bilancio>
    </mat-step>

    <!--  ---------------------- Azioni e Buone Pratiche  ---------- -->
    <mat-step>
      <ng-template matStepLabel> Azioni e Buone Pratiche </ng-template>
      <div appFormContainer [larghezza]="2" class="cont-titolo-step-selezione">
        <div appFormElement [larghezza]="1" [riempi]="true">
          <div class="cont-titolo-targhettina">
            <div class="titolo-sezione-dialog">Selezione delle Azioni e Buone Pratiche</div>
            @if (isStepConsigliato('AZIONIBP')) {
              <div
                class="targhettina-consigliato"
                [matTooltip]="'Consigliato per ' + mappaPriotitaStep['AZIONIBP']?.perStdr"
                matTooltipPosition="right"
              >
                <mat-icon class="material-icons-outlined" style="transform: scale(0.9)">
                  emoji_objects
                </mat-icon>
                *Consigliato
              </div>
            }
          </div>

          <div class="descrizione-sezione-dialog">
            Seleziona le azioni e le buone pratiche che l'azienda mette in atto per le diverse
            tematiche di sostenibilità.

            @if (isStepConsigliato('AZIONIBP')) {
              <br />
              <strong>Step consigliato:</strong> si raccomanda la compilazione delle azioni e buone
              pratiche consigliate per allinearsi alle richieste informative degli
              <i>standard / linee guide selezionate.</i>
            }

            @if (isStepLibero('AZIONIBP')) {
              <br />
              <strong>Step non obbligatorio:</strong> la compilazione delle informazioni non è
              necessaria per allinearsi alle richieste informative degli
              <i>standard / linee guide selezionate.</i>
            }
            @if (isStepObbligatorio('AZIONIBP')) {
              <br />
              Per ogni tematica scelta, è necessario selezionare almeno un azione e buona pratica
            }
            <br />
            Attraverso il pulsante <mat-icon>edit</mat-icon> potrai modificare la descrizione delle
            singole azioni selezionate per rappresentare al meglio le iniziative messe in atto
            dall'azienda, oltre a inserire specifiche istruzioni di compilazione per la figura
            designata all'attività attraverso il campo <i>“Note”</i>.
          </div>
        </div>
      </div>

      <app-selezione-azioni-buonepratiche-bilancio
        nomeModulo="BILANCIO"
        style="padding-right: 20px"
        [prioritaStep]="mappaPriotitaStep['AZIONIBP']?.valore"
        [isPermessoSoloRead]="isPermessoSoloRead"
        [objQuestionario]="objQuestionarioAzioniBP"
        chiaveElemento="elementi"
        [idContest]="this.formCreazioneBilancio.get('id')?.value"
        [stato]="bilancio?.stato"
        [isSoglieSuperate]="isSogliaSuperata()"
        chiaveElementoSelezione="azionebp"
        [settore]="bilancio?.settori"
      >
      </app-selezione-azioni-buonepratiche-bilancio>
    </mat-step>
    <!--  ---------------------- K P I ---------- -->
    <mat-step>
      <ng-template matStepLabel>KPI</ng-template>

      <div appFormContainer [larghezza]="2" class="cont-titolo-step-selezione">
        <div appFormElement [larghezza]="1" [riempi]="true">
          <div class="cont-titolo-targhettina">
            <div class="titolo-sezione-dialog">Selezione dei KPI</div>
            @if (isStepConsigliato('KPI')) {
              <div
                class="targhettina-consigliato"
                [matTooltip]="'Consigliato per ' + mappaPriotitaStep['KPI']?.perStdr"
                matTooltipPosition="right"
              >
                <mat-icon class="material-icons-outlined" style="transform: scale(0.9)">
                  emoji_objects
                </mat-icon>
                *Consigliato
              </div>
            }
          </div>

          <div class="descrizione-sezione-dialog">
            Seleziona i KPI (Key Performance Indicator) che l'azienda misura e monitora. Gli
            indicatori rappresentano tramite dati quantitativi gli impatti che l'azienda ha in
            termini di sostenibilità sulle specifiche tematiche.

            @if (isStepConsigliato('KPI')) {
              <br />
              <strong>Step consigliato:</strong> si raccomanda la compilazione dei KPI consigliati
              per allinearsi alle richieste informative degli
              <i>standard / linee guide selezionate.</i>
            }

            @if (isStepLibero('KPI')) {
              <br />
              <strong>Step non obbligatorio:</strong> la compilazione delle informazioni non è
              necessaria per allinearsi alle richieste informative degli
              <i>standard / linee guide selezionate.</i>
            }
            @if (isStepObbligatorio('KPI')) {
              <br />
              Per ogni tematica scelta, è necessario selezionare almeno un KPI
            }
          </div>
        </div>
      </div>

      <div style="display: flex; flex-direction: column; padding-top: 10px">
        <div
          class="titolo-sezione-dialog"
          style="padding-bottom: 5px; display: flex; align-items: center; column-gap: 15px"
        >
          Includi Anni Precedenti
          <mat-slide-toggle
            labelPosition="before"
            [disabled]="isPermessoSoloRead"
            [(ngModel)]="valueToggleAnni"
            [checked]="valueToggleAnni"
            (change)="cambioToggle($event)"
          >
          </mat-slide-toggle>
        </div>
        <div class="descrizione-sezione-dialog">
          <a
            >Abilita la compilazione dei KPI per gli anni precedenti a quello di rendicontazione
            attraverso il bottone a lato e attiva le funzionalità connesse all'inserimento dello
            storico degli indicatori.
            <br />
            <a style="font-weight: bold">Nota:</a> Nei Bilanci di Sostenibilità è buona prassi
            rendicontare i dati relativi al biennio precedente a quello di rendicontazione.</a
          >
        </div>
      </div>

      <app-selezione-kpi-bilancio
        nomeModulo="BILANCIO"
        [prioritaStep]="mappaPriotitaStep['KPI']?.valore"
        style="padding-right: 20px"
        [isPermessoSoloRead]="isPermessoSoloRead"
        [objQuestionario]="objQuestionarioKPI"
        chiaveElemento="elementi"
        [idContest]="this.formCreazioneBilancio.get('id')?.value"
        [stato]="bilancio?.stato"
        chiaveElementoSelezione="kpi"
        [isSoglieSuperate]="isSogliaSuperata()"
        [settore]="bilancio?.settori"
      >
      </app-selezione-kpi-bilancio>
    </mat-step>
    <!--  ---------------------- Certificazioni  ---------- -->
    <mat-step>
      <ng-template matStepLabel>Certificazioni</ng-template>

      <div appFormContainer [larghezza]="2" class="cont-titolo-step-selezione">
        <div appFormElement [larghezza]="1" [riempi]="true">
          <div class="cont-titolo-targhettina">
            <div class="titolo-sezione-dialog">Selezione delle Certificazioni</div>
            @if (isStepConsigliato('CERTIFICAZIONI')) {
              <div
                class="targhettina-consigliato"
                [matTooltip]="'Consigliato per ' + mappaPriotitaStep['CERTIFICAZIONI']?.perStdr"
                matTooltipPosition="right"
              >
                <mat-icon class="material-icons-outlined" style="transform: scale(0.9)">
                  emoji_objects
                </mat-icon>
                *Consigliato
              </div>
            }
          </div>

          <div class="descrizione-sezione-dialog">
            Seleziona le certificazioni possedute dall’azienda

            @if (isStepConsigliato('CERTIFICAZIONI')) {
              <br />
              <strong>Step consigliato:</strong> si raccomanda la compilazione delle certificazioni
              consigliati per allinearsi alle richieste informative degli
              <i>standard / linee guide selezionate.</i>
            }
            @if (isStepLibero('CERTIFICAZIONI')) {
              <br />
              <strong>Step non obbligatorio:</strong> la compilazione delle informazioni non è
              necessaria per allinearsi alle richieste informative degli
              <i>standard / linee guide selezionate.</i>
            }
          </div>
        </div>
      </div>

      <app-selezione-certificazioni-bilancio
        nomeModulo="BILANCIO"
        style="padding-right: 20px"
        [prioritaStep]="mappaPriotitaStep['CERTIFICAZIONI']?.valore"
        [isPermessoSoloRead]="isPermessoSoloRead"
        [objQuestionario]="objQuestionarioCertificazioni"
        chiaveElemento="elementi"
        [idContest]="this.formCreazioneBilancio.get('id')?.value"
        [stato]="bilancio?.stato"
        chiaveElementoSelezione="certif"
        [settore]="bilancio?.settori"
      >
      </app-selezione-certificazioni-bilancio>
    </mat-step>
    <!--  ---------------------- C R U S C O T T O ---------- -->
    <mat-step>
      <ng-template matStepLabel> Cruscotto </ng-template>
      <div class="barra-titolo-cruscotto">
        <div style="display: flex; flex-direction: column; flex: 1">
          <div class="titolo-sezione-dialog">
            {{ isUtenteGo ? 'Cruscotto Report Tematico' : 'Cruscotto Report di Sostenibilità' }}
          </div>

          <div class="descrizione-sezione-dialog">
            Visualizza e gestisci ogni aspetto relativo alla compilazione: avanzamento,
            configurazione dei testi mail, invio e notifiche.
          </div>
        </div>

        <!-- TOTALI CRUSCOTTO -->
        @if (this.formCreazioneBilancio.get('id')?.value) {
          <app-totali-cruscotto
            #totaliCruscotto
            [tipoModulo]="'BILANCIO'"
            [idModulo]="this.formCreazioneBilancio.get('id')?.value"
          >
          </app-totali-cruscotto>
        }
      </div>
      <ng-scrollbar>
        <div style="padding-right: 20px">
          <app-lista-tabellare
            #tabella
            [defaultPageSize]="4"
            [fnCaricamentoDati]="fnCaricamentoDatiCruscotto"
            [colonne]="colonne"
            [maxNrButton]="1"
            [filtri]="filtri"
            (bottoniListaClick)="bottoniListaClick($event)"
            *ngIf="this.formCreazioneBilancio.get('id')?.value"
          >
            <ng-container btnEnd>
              <button
                [disabled]="!isPermessoInvioMail"
                mat-flat-button
                class="primary-button"
                color="primary"
                (click)="template()"
              >
                <mat-icon matSuffix>settings</mat-icon>
                Config. Testi
              </button>

              <button
                [disabled]="!isPermessoInvioMail || isPermessoSoloRead"
                mat-flat-button
                class="primary-button"
                color="primary"
                (click)="inviaTutti()"
              >
                <mat-icon matSuffix>mail</mat-icon>
                Invia a Tutti
              </button>

              <button
                [disabled]="!isPermessoInvioMail || isPermessoSoloRead"
                mat-flat-button
                class="primary-button"
                color="primary"
                (click)="notificaTutti()"
              >
                <mat-icon matSuffix>notifications_active</mat-icon>
                Notifica Tutti
              </button>
            </ng-container>
          </app-lista-tabellare>
        </div>
      </ng-scrollbar>
    </mat-step>
    <!--  ---------------------- S T A M P A ---------- -->
    <mat-step>
      <ng-template matStepLabel> Configurazione Stampa </ng-template>

      <app-cfg-stampa
        [isPermessoSoloRead]="isPermessoSoloRead"
        [fnGetConfigStampa]="fnGetConfigStampa"
        style="padding-right: 20px"
        [fnSalvaCfgStampa]="fnSalvaCfgStampa"
        [fnCaricaImg]="fnImportaImmagine"
        [fnEliminaImg]="fnEliminaImg"
        (loading)="toggleLoading($any($event))"
        [titolo]="
          'Seleziona e compila gli elementi che compongono il Report di Sostenibilità dell\'azienda'
        "
      ></app-cfg-stampa>
    </mat-step>
  </mat-stepper>
</div>
<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button
      mat-flat-button
      color="accent"
      [disabled]="stepper.selectedIndex === 0"
      (click)="indietro()"
      class="accent-button"
    >
      Indietro
    </button>
  </div>
  <ng-container *ngIf="stepper.selectedIndex !== 9">
    <div>
      <button
        mat-flat-button
        color="primary"
        (click)="avantiHTML()"
        class="primary-button"
        #btnAvanti
      >
        Avanti
      </button>
    </div>

    <div *ngIf="mostraBottoneAssegnazioni">
      <button
        mat-flat-button
        color="primary"
        (click)="assegnazioni(stepper.selectedIndex)"
        class="primary-button"
      >
        <mat-icon>person_edit</mat-icon>
        Assegnazioni
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="stepper.selectedIndex === 9">
    <button
      *ngIf="!isPermessoSoloRead"
      mat-flat-button
      color="primary"
      (click)="salvaCfgStampa()"
      class="primary-button"
    >
      Salva
    </button>
    <button
      *ngIf="isPermessoSoloRead"
      mat-flat-button
      color="primary"
      matDialogClose
      class="primary-button"
    >
      Chiudi
    </button>
    <button
      [disabled]="!this.cfgStampaComponent.isPermessoStampa"
      mat-flat-button
      color="accent"
      (click)="stampa()"
      class="accent-button"
      style="margin: 0 !important"
    >
      <mat-icon class="material-icons-outlined"> print </mat-icon>
      Stampa
    </button>
  </ng-container>
</div>
